import { Flame, Star, Target } from "lucide-react";

interface WeeklySummaryHeroProps {
  completedCount: number;
  streak: number;
  bestSignal: string;
  focusArea: string;
}

export const WeeklySummaryHero = ({ completedCount, streak, bestSignal, focusArea }: WeeklySummaryHeroProps) => {
  return (
    <div className="bg-gradient-to-br from-primary/10 via-primary/5 to-background border rounded-3xl p-6 shadow-soft relative overflow-hidden">
      <div className="absolute -top-10 -right-10 w-32 h-32 bg-primary/10 rounded-full blur-3xl"></div>
      
      <div className="flex items-center justify-between mb-6 relative z-10">
        <div>
          <p className="text-sm font-medium text-muted-foreground">Resumen Semanal</p>
          <h2 className="text-2xl font-bold text-foreground">{completedCount}/7 check-ins</h2>
        </div>
        <div className="bg-background border rounded-xl px-3 py-1.5 flex items-center gap-1.5 shadow-sm">
          <Flame className="h-4 w-4 text-orange-500" />
          <span className="text-sm font-bold">{streak} {streak === 1 ? 'día' : 'días'}</span>
        </div>
      </div>

      <div className="flex flex-col gap-3 relative z-10">
        {bestSignal && (
          <div className="flex items-center gap-3 bg-card/80 backdrop-blur-sm border rounded-xl p-3">
            <div className="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center shrink-0">
              <Star className="h-4 w-4" />
            </div>
            <div>
              <p className="text-[10px] font-bold text-muted-foreground uppercase tracking-wider">Mejor Señal</p>
              <p className="text-sm font-medium text-foreground">{bestSignal}</p>
            </div>
          </div>
        )}
        
        {focusArea && (
          <div className="flex items-center gap-3 bg-card/80 backdrop-blur-sm border rounded-xl p-3">
            <div className="w-8 h-8 rounded-lg bg-wellness-peach/10 text-wellness-peach-dark flex items-center justify-center shrink-0">
              <Target className="h-4 w-4" />
            </div>
            <div>
              <p className="text-[10px] font-bold text-muted-foreground uppercase tracking-wider">Foco Actual</p>
              <p className="text-sm font-medium text-foreground">{focusArea}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
